<template>
    <div id="tryoutgroup-chooser">
        <div class="input-group">
            <button type="button" class="btn btn-inverse" @click="openGroupModal" v-if="$route.name !== 'DetailPaketMapel'">Pilih ...</button>
        </div>
        <transition name="modal" v-if="showModal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div id="modal" class="modal-container">
                    <div class="modal-header" v-if="$route.name !== 'DetailPaketMapel'">Pilih Prasyarat</div>
                    <div class="modal-header" v-if="$route.name === 'DetailPaketMapel'">Pilih Tryout</div>
                    <div class="modal-body">
                        <app-datatable :items="rows" :headers="headers" :hasAction="false" v-on:dblClicked="onTryoutGroupChoosen($event)"></app-datatable>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" @click="showModal = false">Close</button>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>
<style scoped>
.modal-container {
  width: 50%;
}
</style>
<script>
import Spinner from '@/components/plugins/Spinner'
import DataTable from '@/components/plugins/DataTable'
import TryoutService from '@/services/tryout.js'

export default {
    name: 'tryoutgroup-chooser',
    props: ['params'],
    components: {
        'app-spinner': Spinner,
        'app-datatable': DataTable,
    },
    data: function () {
        return {
            isLoading: false,
            showModal: false,
            headers: ['Tryout Group', 'Tipe', 'Kelas'],
            rows: []
        }
    },
    methods: {
        openGroupModal: function () {
            var date = new Date()
            var timestamp = date.getTime()

            this.isLoading = true
            this.showModal = true

            var context = this
            TryoutService.getListOfTryoutGroups(null, null, this.params, function (response) {
                if (response.success) {
                    context.rows = []
                    response.data.forEach(function (data) {
                        // console.log(data)
                        var row = {
                            id: data.id,
                            data: [data.name, data.type, data.grade]
                        }
                        if(context.$route.name === 'DetailPaketMapel' && data.closed_at > timestamp) {
                            console.log(data.closed_at)
                            console.log(timestamp)
                            context.rows.push(row)
                        }
                    })
                }

                context.isLoading = false
            }, this.grade, null).catch(function (error) {
                context.isLoading = false
            })
        },
        onTryoutGroupChoosen: function (group) {
            this.showModal = false
            this.$emit('dblClicked', group)
        }
    }
}
</script>


// WEBPACK FOOTER //
// TryoutGroupChooser.vue?f3a77604